interface IAccessLevels {
    [key: string]: number;
}
export const ACCESS_LEVELS: IAccessLevels = {
    disabled: 0,
    dev: 1,
    staging: 2,
    uat: 3,
    prod: 4,
};

export const FEATURE_SET: keyof IAccessLevels = process.env.REACT_APP_DEV_FEATURE_SET as unknown as keyof IAccessLevels;

export const FEATURE_LEVEL = {
    viewPartnerEmployer: ACCESS_LEVELS.prod,
    invitationEmail: ACCESS_LEVELS.prod,
};

export const hasFeatureEnabled = (access: number): boolean => {
    return !!(ACCESS_LEVELS[FEATURE_SET] && access >= ACCESS_LEVELS[FEATURE_SET]);
};
